import _, { isArray } from "lodash";
import isEmpty from "lodash/isEmpty";
import qs from "qs";
import IOTUtilService from "./IOTUtilService";
import PrinterUtilService from "./PrinterUtilService";
import { axiosBlobInstance } from "./SmartScaleService";
import { isDayjs } from "dayjs";

var iotUtilService = new IOTUtilService();
const printerUtilService = new PrinterUtilService();

export default {
  // Printer
  getPrinterSOS: function (params) {
    let api = `/device/v1/printer/sos`;
    return printerUtilService.get(api, { params });
  },
  getListCodPrinter: function (params) {
    let api = `/device/v1/printer/username-cods`;
    return printerUtilService.get(api, { params });
  },
  exportPrinter: function (params) {
    let api = `/device/v1/printer/printers-export`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },
  getList: function (params) {
    let api = `/device/v1/printer/printers`;
    return printerUtilService.get(api, { params });
  },
  getDetailHistory: function (params) {
    let api = `/device/v1/printer/repair-history`;
    return printerUtilService.get(api, { params });
  },
  getPrinterSurvey: function (params) {
    let api = `/device/v1/printer/surveys`;
    return iotUtilService.get(api, { params });
  },
  deletePrinterSurvey: function (params) {
    let api = `device/v1/printer/surveys/${params.printer_mac}`;
    return iotUtilService.delete(api);
  },
  getFilterPrinterSurvey: function () {
    let api = `device/v1/printer/surveys/filter-data`;
    return iotUtilService.get(api);
  },
  sendPrinterSOS: function (params) {
    let api = `device/v1/printer/surveys/sos?type=${params.type}&printer_type=${
      params.printer_type
    }`;
    return iotUtilService.get(api);
  },
  sendPrinterSpecifiedSOS: function (params) {
    let api = `device/v1/printer/surveys/sos/specified`;
    return iotUtilService.get(api, { params });
  },
  updatePrinterSurvey: function (data) {
    let api = `device/v1/printer/surveys/next-survey`;
    return iotUtilService.post(api, data);
  },
  resetPrinterSurvey: function (data) {
    let api = `device/v1/printer/surveys/reset?mac=${data.mac}`;
    return iotUtilService.post(api);
  },
  changePrinterStatus: function (params) {
    let api = `device/v1/printer/surveys/blacklist`;
    return iotUtilService.post(api, params);
  },
  getReportWeek: function () {
    let api = `/device/v1/printer/statistics/repair-by-week`;
    return printerUtilService.get(api);
  },
  getActivity: function () {
    let api = `/device/v1/printer/statistics/status`;
    return printerUtilService.get(api);
  },
  getPrinterTagNoOfUse: function () {
    let api = `/device/v1/printer/statistics/day-of-use`;
    return printerUtilService.get(api);
  },
  getPrinterTagRecentDate: function () {
    let api = `/device/v1/printer/statistics/recent-date`;
    return printerUtilService.get(api);
  },
  getPrinterTag: function (params) {
    let api = `device/v1/printer/statistics/tag-list`;
    return printerUtilService.get(api, { params });
  },
  getWhoUse: function (params) {
    let api = `/device/v1/printer/printer-users`;
    return printerUtilService.get(api, { params });
  },
  getUseAble: function (param) {
    let api = `/printer/api/getPrinterByUser?printer_type=${
      param.printer_type
    }&username=${param.printer_owner}`;
    return printerUtilService.get(api);
  },
  savePrinterOwner: function (param) {
    let api = "/printer/api/updatePrinterOwner";
    return printerUtilService.post(api, param);
  },
  savePrinterSOS: function (param) {
    let api = "/printer/api/createSOSPrinter";
    // let jsonVal = JSON.stringify(param);
    return printerUtilService.post(api, param);
  },
  dowloadData: function (param) {
    let api = `/device/v1/printer/printers?limit=9999999&offset=${
      param.offset
    }`;

    if (!isEmpty(param.printer_type)) {
      api = api + `&printer_type=${param.printer_type}`;
    }
    if (!isEmpty(param.station_id)) {
      let jsonStation = JSON.stringify(param.station_id);
      api = api + `&station_id=${jsonStation}`;
    }
    if (!isEmpty(param.printer_status)) {
      api = api + `&printer_status=${param.printer_status}`;
    }
    if (!isEmpty(param.printer_mac)) {
      api = api + `&printer_mac=${param.printer_mac}`;
    }
    if (!isEmpty(param.printer_owner)) {
      let json = JSON.stringify(param.printer_owner);
      api = api + `&printer_owner=${json}`;
    }
    if (!isEmpty(param.from)) {
      api = api + `&from=${param.from}`;
    }
    if (!isEmpty(param.to)) {
      api = api + `&to=${param.to}`;
    }
    if (!isEmpty(param.selectTag)) {
      Object.keys(param.selectTag).forEach(function (key) {
        api = api + `&` + key + `=${JSON.stringify(param.selectTag[key])}`;
      });
    }

    if (Object.keys(param.param_order).length > 0) {
      let myJSON = JSON.stringify({
        recent_activity: 1,
      });
      api = api + `&param_order=${myJSON}`;
    }
    api = api + `&download_flg=1`;
    return printerUtilService.getCustom(api);
  },

  // Camera
  getListVideo: function (param) {
    let api = `/camera/manage/searchVideos?limit=${param.limit}&offset=${
      param.offset
    }`;
    if (!isEmpty(param.pkg_order)) {
      api = api + `&pkg_order=${param.pkg_order}`;
    }
    if (!isEmpty(param.sort)) {
      api = api + `&sort=${param.sort}`;
    }
    if (!isEmpty(param.station_id)) {
      // let jsonStation = JSON.stringify(param.station_id);
      api = api + `&station_id=${param.station_id}`;
    }
    if (!isEmpty(param.time_start)) {
      api =
        api +
        `&time_start=${
          isDayjs(param.time_start)
            ? param.time_start.startOf("day").valueOf()
            : undefined
        }`;
    }
    if (!isEmpty(param.time_stop)) {
      api =
        api +
        `&time_stop=${
          isDayjs(param.time_stop)
            ? param.time_stop.endOf("day").valueOf()
            : undefined
        }`;
    }
    if (!isEmpty(param.action)) {
      api = api + `&action=${param.action}`;
    }

    return iotUtilService.get(api);
  },
  getListVideoByPkg: function (param) {
    if (param.pkg_order) {
      let api = `/camera/v2/pkg-orders/${
        param.pkg_order
      }/order-videos?platform=web`;

      return iotUtilService.get(api);
    }
    return null;
  },
  getListVideoByBag: function (param) {
    if (param.bag_order) {
      let api = `/camera/v2/bag-orders/${
        param.bag_order
      }/order-videos?platform=web`;

      return iotUtilService.get(api);
    }
    return null;
  },
  getListVideoByBox: function (param) {
    if (param.box_id) {
      let api = `/camera/v2/green-boxs/${param.box_id}/videos?platform=web`;

      return iotUtilService.get(api);
    }
    return null;
  },
  getListLog: function (param) {
    if (!param.station_id) {
      return null;
    }
    let api = `/camera/manage/getPkgWithoutRouteByStation/${
      param.station_id
    }?limit=${param.limit}&offset=${param.offset}`;
    if (!isEmpty(param.pkg_order)) {
      api = api + `&pkg_order=${param.pkg_order}`;
    }
    if (!isEmpty(param.sort)) {
      api = api + `&sort=${param.sort}`;
    }
    if (!isEmpty(param.station_id)) {
      // let jsonStation = JSON.stringify(param.station_id);
      api = api + `&station_id=${param.station_id}`;
    }
    if (!isEmpty(param.time_start)) {
      api =
        api +
        `&time_start=${
          isDayjs(param.time_start)
            ? param.time_start.startOf("day").valueOf()
            : undefined
        }`;
    }
    if (!isEmpty(param.time_stop)) {
      api =
        api +
        `&time_stop=${
          isDayjs(param.time_stop)
            ? param.time_stop.endOf("day").valueOf()
            : undefined
        }`;
    }
    if (!isEmpty(param.action)) {
      api = api + `&action=${param.action}`;
    }

    return iotUtilService.get(api);
  },
  getListStationStatistic: function (params) {
    let api = `/camera/v2/reports/stations`;
    if (isDayjs(params.from)) {
      params.from = params.from.startOf("day").unix();
    }
    if (isDayjs(params.to)) {
      params.to = params.to.endOf("day").unix();
    }
    return iotUtilService.get(api, { params });
  },
  getBagLog: function (params) {
    let api = `/camera/v2/reports/bag-log-in-stations`;
    return iotUtilService.get(api, {
      params,
    });
  },
  getListDvrByStation: function (stationId) {
    let api = `/camera/v2/stations/${stationId}/dvrs`;
    return iotUtilService.get(api);
  },
  getListDvrInfo: function (param) {
    let api = `/camera/v2/dvrs`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  getListDvrInfoV2: function (param) {
    let api = `/camera/v2/dvrs/attach-channels`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  changeChannelState: function (channel_id, param) {
    let api = `/camera/v2/channels/${channel_id}/change-type`;
    return iotUtilService.put(api, param);
  },
  changeAngleCoverage: function (channel_id, param) {
    let api = `/camera/v2/channels/${channel_id}/fields`;
    return iotUtilService.put(api, param);
  },
  changeChannelName: function (channel_id, param) {
    let api = `/camera/v2/channels/${channel_id}`;
    return iotUtilService.put(api, param);
  },
  getChannelInfoByDvr: function (dvr_id) {
    let api = `/camera/v2/dvrs/${dvr_id}/channels`;
    return iotUtilService.get(api);
  },
  getChannelInfoByStation: function (station_id) {
    let api = `/camera/v2/stations/${station_id}/channels`;
    return iotUtilService.get(api);
  },
  getScenarioInfoByStation: function (station_id) {
    let api = `/camera/manage/getScenarioInfo?station_id=${station_id}`;
    return iotUtilService.get(api);
  },
  getSetupByStation: function (station_id) {
    let api = `/camera/manage/getScenarioConfig?station_id=${station_id}`;
    return iotUtilService.get(api);
  },
  getModuleByStation: function (station_id) {
    let stationStr = station_id;
    if (isArray(station_id)) {
      stationStr = `[${stationStr}]`;
    }
    let api = `/camera/v2/modules?station_ids=${stationStr}`;
    return iotUtilService.get(api);
  },
  getCartByStation: function (station_id) {
    let stationStr = station_id;
    if (isArray(station_id)) {
      stationStr = `[${stationStr}]`;
    }
    let api = `/camera/v2/carts?station_ids=${stationStr}`;
    return iotUtilService.get(api);
  },
  browseJobVideosStatus: function (param = {}) {
    let api = `/camera/manage/getJobVideosStatus`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  browseMostError: function (
    param = {
      quantity: 20,
    }
  ) {
    let api = `/camera/manage/getMostErrorDvr`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  browseServer: function (param = {}) {
    let api = `/camera/v2/servers`;
    if (!isEmpty(param.server_name)) {
      api = api + `server_name=${param.server_name}`;
    }
    if (!isEmpty(param.status)) {
      api = api + `&status=${param.status}`;
    }
    return iotUtilService.get(api);
  },
  addServer: function (server) {
    let api = `/camera/v2/servers`;
    return iotUtilService.post(api, server);
  },
  editServer: function (server) {
    let api = `/camera/v2/servers/${server.server_id}`;
    if (server.server_id) delete server.server_id;
    return iotUtilService.put(api, server);
  },
  deleteServer: function (serverId) {
    let api = `/camera/v2/servers/${serverId}`;
    return iotUtilService.delete(api);
  },
  createScenario: function (scenario) {
    scenario.dvr_info = JSON.stringify(scenario.dvr_info);
    scenario.inbound_info = JSON.stringify(scenario.inbound_info);
    scenario.inhouse_info = JSON.stringify(scenario.inhouse_info);
    scenario.outbound_info = JSON.stringify(scenario.outbound_info);
    let api = `/camera/manage/createScenarioInfo`;
    return iotUtilService.post(api, scenario);
  },
  createDvr: function (dvr) {
    let api = `/camera/v2/admin/dvrs`;
    return iotUtilService.post(api, dvr);
  },
  createDvrMod: function (dvr) {
    let api = `/camera/v2/dvrs`;
    return iotUtilService.post(api, dvr);
  },
  updateDvr: function (dvr) {
    let api = `/camera/v2/admin/dvrs/${dvr.dvr_id}`;
    if (dvr.dvr_id) delete dvr.dvr_id;
    return iotUtilService.put(api, dvr);
  },
  updateDvrMod: function (dvr) {
    let api = `/camera/v2/dvrs/${dvr.dvr_id}`;
    if (dvr.dvr_id) delete dvr.dvr_id;
    return iotUtilService.put(api, dvr);
  },
  exportDvrInfosByStation: function (param) {
    let api = `/camera/manage/exportDvrInfosByStation`;
    return iotUtilService.post(api, param);
  },
  // api để khoá đầu thu
  lockDvr: function (dvr_id) {
    let api = `/camera/v2/admin/dvr-locking`;
    let lock_flg = 1;
    let platform = "web";
    return iotUtilService.put(
      api,
      { lock_flg },
      { params: { dvr_id, platform } }
    );
  },
  // api để mở khoá đầu thu
  unlockDvr: function (dvr_id) {
    let api = `/camera/v2/admin/dvr-locking`;
    let lock_flg = 0;
    let platform = "web";
    return iotUtilService.put(
      api,
      { lock_flg },
      { params: { dvr_id, platform } }
    );
  },
  lockTruckCamera: function (channel_id) {
    let api = `/camera/v2/truck-cameras/${channel_id}/locking`;
    let lock_flg = 1;
    let platform = "web";
    return iotUtilService.put(api, { lock_flg }, { params: { platform } });
  },
  unlockTruckCamera: function (channel_id) {
    let api = `/camera/v2/truck-cameras/${channel_id}/locking`;
    let lock_flg = 0;
    let platform = "web";
    return iotUtilService.put(api, { lock_flg }, { params: { platform } });
  },
  deleteDvr: function (dvr_id) {
    let api = `/camera/v2/dvrs/${dvr_id}`;
    return iotUtilService.delete(api);
  },
  deleteScenario: function (scenario_id) {
    let api = `/camera/manage/deleteScenarioInfo/${scenario_id}`;
    return iotUtilService.delete(api);
  },
  deleteSetup: function (setup_id) {
    let api = `/camera/manage/deleteScenarioConfig/${setup_id}`;
    return iotUtilService.delete(api);
  },
  createSetup: function (setup) {
    let api = `/camera/manage/createScenarioConfig`;
    let param = {};
    _.forEach(setup, (fieldValue, fieldName) => {
      if (fieldName === "station_dest_id") {
        fieldValue = _.map(fieldValue, _.parseInt);
      }
      param[fieldName] = _.isArray(fieldValue)
        ? JSON.stringify(fieldValue)
        : fieldValue;
    });
    let data = qs.stringify(param);
    return iotUtilService.post(api, data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  setRouteConfig: function (routeConfig) {
    let api = `/camera/manage/createRouteConfig`;
    let param = {};
    _.forEach(routeConfig, (fieldValue, fieldName) => {
      if (fieldName === "station_dest_id") {
        fieldValue = _.map(fieldValue, _.parseInt);
      }
      param[fieldName] = _.isArray(fieldValue)
        ? JSON.stringify(fieldValue)
        : fieldValue;
    });
    var data = qs.stringify(param);
    return iotUtilService.post(api, data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  getMe: function () {
    let api = `/camera/v2/me`;
    return iotUtilService.get(api);
  },
  createUserPermission: function (data) {
    let api = `/camera/v2/user-permissions`;
    return iotUtilService.post(api, data);
  },
  deleteUserPermission: function (_id) {
    let api = `/camera/v2/user-permissions/${_id}`;
    return iotUtilService.delete(api);
  },
  updateUserPermission: function (data) {
    let api = `/camera/v2/user-permissions/${data.permission_id}`;
    if (data.permission_id) delete data.permission_id;
    return iotUtilService.put(api, data);
  },
  searchUserByUserName: function (userName) {
    let api = `/camera/v2/users?username=${userName}`;
    return iotUtilService.get(api);
  },
  searchUser: function (param) {
    let api = `/camera/v2/user-permissions`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  createNewCamera: function (data) {
    let api = `/camera/v2/settings`;
    return iotUtilService.post(api, data);
  },
  updateCamera: function (data) {
    let api = `/camera/v2/settings/${data.setting_id}`;
    if (data.setting_id) delete data.setting_id;
    return iotUtilService.put(api, data);
  },
  deleteCamera: function (_id) {
    let api = `/camera/v2/settings/${_id}`;
    return iotUtilService.delete(api);
  },
  deleteSetting: function (setting_id) {
    let api = `/camera/v2/settings/${setting_id}`;
    return iotUtilService.delete(api);
  },
  searchCamera: function (param) {
    let api = `/camera/v2/settings`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  searchNetworkInfo: function (param) {
    let api = `/camera/manage/getNetworkInfos`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  getCameraSettingByKey: function (key) {
    let api = `/camera/v2/settings/key/${key}`;
    return iotUtilService.get(api);
  },
  createUserLogs: function (data) {
    let api = `/camera/v2/effect-logs`;
    return iotUtilService.post(api, data);
  },
  getUserLogs: function (params) {
    let api = `/camera/v2/effect-logs`;
    return iotUtilService.get(api, {
      params,
    });
  },
  getListActionLogUser: function (params) {
    let api = `/camera/v2/settings/key/LIST_ACTION_IN_USER_LOG`;
    return iotUtilService.get(api, { params });
  },
  getStationInfos: (param) => {
    let api = `/camera/v2/stations`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  getListJobVideos: function (params) {
    let api = `/camera/v2/job-video-down-reqs`;
    return iotUtilService.get(api, { params });
  },
  pushJobToQueue: function (params) {
    let api = `/camera/v2/job-video-down-reqs/retry`;

    return iotUtilService.put(api, params, { params });
  },

  // getStationNewInfos: param => {
  //   let api = `/tracker/stations`;
  //   return iotUtilService.get(api, {
  //     params: param
  //   });
  // },
  getStationCameraGeoJson: (param) => {
    let api = `/camera/v2/stations/geojson`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  deleteScenarioPlace: (param) => {
    let api = `/camera/v2/blocks/${param}/internal-scenarios`;
    return iotUtilService.delete(api);
  },
  deleteScenarioBC: (param) => {
    let api = `camera/v2/internal-scenarios/${param}`;
    return iotUtilService.delete(api);
  },
  getCameraConfigByPlace: (param) => {
    let api = `/camera/v2/internal-scenarios`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  createConfigPlace: (data) => {
    let api = `/camera/v2/blocks/internal-scenarios`;
    return iotUtilService.post(api, data);
  },
  updateConfigPlace: (data) => {
    let api = `camera/v2/blocks/${data.block_id}/internal-scenarios`;
    if (data.block_id) delete data.block_id;
    return iotUtilService.put(api, data);
  },
  createConfig: (data) => {
    let api = `/camera/v2/internal-scenarios`;
    return iotUtilService.post(api, data);
  },
  updateConfig: (data) => {
    let api = `/camera/v2/internal-scenarios/${data._id}`;
    if (data._id) delete data._id;
    return iotUtilService.put(api, data);
  },
  getCameraActionConfigsInfo: () => {
    let api = `/camera/v2/action-configs`;
    return iotUtilService.get(api);
  },
  saveCameraActionConfig: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/camera/v2/action-configs/${data.action_cfg_id}`;
      if (data.action_cfg_id) delete data.action_cfg_id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/camera/v2/action-configs`;
      return iotUtilService.post(api, data);
    }
  },
  deleteCameraActionConfig: (_id) => {
    let api = `/camera/v2/action-configs/${_id}`;
    return iotUtilService.delete(api);
  },
  //lấy danh sách quản lý camera xe tải
  getTruckCameraInfos: (params) => {
    let api = `/camera/v2/truck-cameras`;
    return iotUtilService.get(api, {
      params,
    });
  },
  //lấy danh sách quản lý camera xe thuê
  getRentalTruckCameraInfos: (params) => {
    let api = `/camera/v2//truck-dvrs`;
    return iotUtilService.get(api, {
      params,
    });
  },
  //tạo mới đầu thu xe thuê
  createRentalTruckCamera: (data) => {
    let api = `/camera/v2//truck-dvrs`;
    return iotUtilService.post(api, data);
  },
  //xoá đầu thu xe thuê
  deleteRentalTruckCamera: (id) => {
    let api = `/camera/v2//truck-dvrs/${id}`;
    return iotUtilService.delete(api);
  },
  //update đầu thu xe thuê
  syncTruckCamera: () => {
    let api = `/camera/v2/truck-cameras/cb3-sync`;
    return iotUtilService.get(api);
  },
  updateRentalTruckCamera: (param) => {
    let api = `/camera/v2/truck-dvrs/${param.id}`;
    if (param.id) delete param.id;
    return iotUtilService.put(api, param);
  },
  exportTruckCameraStatuses: (param) => {
    let api = `/camera/v2/truck-cameras/status/export`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  getSNInfos: () => {
    let api = `/camera/v2/truck-cameras/sn`;
    return iotUtilService.get(api);
  },
  createTruckCamera: (data) => {
    let api = `/camera/v2/truck-cameras`;
    return iotUtilService.post(api, data);
  },
  deleteTruckCamera: (param) => {
    let api = `/camera/v2/truck-cameras/${param._id}`;
    return iotUtilService.delete(api);
  },
  updateTruckCamera: (param) => {
    let api = `/camera/v2/truck-cameras/${param.id}`;
    if (param.id) delete param.id;
    return iotUtilService.put(api, param);
  },
  //thêm log sửa chữa cho camera xe tải
  createTruckCameraRepairLog: (data) => {
    let api = `/camera/v2/truck-camera-repair-logs`;
    return iotUtilService.post(api, data);
  },
  //sửa log sửa chữa cho camera xe tải
  updateTruckCameraRepairLog: (id, data) => {
    let api = `/camera/v2/pkg-logs/${id}`;
    return iotUtilService.put(api, data);
  },
  //xoá log sửa chữa cho camera xe tải
  deleteTruckCameraRepairLog: (id) => {
    let api = `/camera/v2/truck-camera-repair-logs/${id}`;
    return iotUtilService.delete(api);
  },
  //lấy log sửa chữa của camera xe tải
  getTruckCameraRepairLog: (params) => {
    let api = `/camera/v2/truck-camera-repair-logs`;
    return iotUtilService.get(api, {
      params,
    });
  },
  getDvrDashboardInfo: () => {
    let api = `/camera/v2/reports/dvrs`;
    return iotUtilService.get(api);
  },
  getAllLicensePlate: () => {
    let api = `/camera/manage/getLicensePlates`;
    return iotUtilService.get(api);
  },
  getPkgLogByOrder: (pkg_order) => {
    let api = `/camera/v2/pkg-orders/${pkg_order}/pkg-logs`;
    return iotUtilService.get(api);
  },
  updatePkgLog: (id, data) => {
    let api = `/camera/v2/pkg-logs/${id}`;
    return iotUtilService.put(api, data);
  },
  getTruckInfoOfIOT(param) {
    let api = `/camera/v2/trucks/${param.license_plate}`;
    return iotUtilService.get(api);
  },
  getAllLicensePlateOfIOT() {
    let api = `/camera/v2/trucks`;
    return iotUtilService.get(api);
  },
  getCameraPermissionList(param) {
    let api = `/camera/v2/extend-permissions`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  deleteUserCameraPermission(id) {
    let api = `/camera/v2/extend-permissions/${id}`;
    return iotUtilService.delete(api);
  },
  updateUserCameraPermission(data, _id) {
    let api = `/camera/v2/extend-permissions/${_id}`;
    if (data._id) delete data._id;
    return iotUtilService.put(api, data);
  },
  searchUserByUserNameExtendPermission: function (userName) {
    let api = `/camera/v2/users?username=${userName}`;
    return iotUtilService.get(api);
  },
  createUserCameraPermission: function (data) {
    let api = `/camera/v2/extend-permissions`;
    return iotUtilService.post(api, data);
  },
  getCrossScenarioByStation: function (station_id) {
    let api = `/camera/v2/cross-scenarios?station_id=${station_id}`;
    return iotUtilService.get(api);
  },
  createCrossScenario: function (data) {
    let api = `/camera/v2/cross-scenarios`;
    return iotUtilService.post(api, data);
  },
  updateCrossScenario: function (data, _id) {
    let api = `/camera/v2/cross-scenarios/${_id}`;
    if (data._id) delete data._id;
    return iotUtilService.put(api, data);
  },
  deleteCrossScenario: function (_id) {
    let api = `/camera/v2/cross-scenarios/${_id}`;
    return iotUtilService.delete(api);
  },
  getTruckCameraDashboard: () => {
    let api = `/camera/v2/truck-cameras/dashboard`;
    return iotUtilService.get(api);
  },
  getListAssets(param) {
    let api = `/camera/v2/truck-equipments`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  editAsset(data) {
    let api = `/camera/v2/truck-equipments`;
    return iotUtilService.put(api, data);
  },
  //tải báo cáo quản lý tài sản
  exportListAssets: function (params) {
    let api = `/camera/v2/truck-equipments/export`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },
  //lấy danh sách cam cửa chính (màn kiểm tra giờ làm)
  getMainDoorListCamera(param) {
    let api = `/camera/v2/main-door/channels`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  //config thời gian chụp ảnh (kiểm tra giờ làm)
  updateMainDoorTimeConfig(data, _id) {
    let api = `/camera/v2/main-door/channels/${_id}`;
    return iotUtilService.put(api, data);
  },
  updateAllMainDoorTimeConfig(data) {
    let api = `/camera/v2/main-door/channels-config-time/all`;
    return iotUtilService.put(api, data);
  },
  getChannelConfigTime() {
    let api = `/camera/v2/main-door/channels-config-time/get-config`;
    return iotUtilService.get(api);
  },
  //lấy danh sách phân quyền camera người dùng
  getListUserCameraPermission(param) {
    let api = `/camera/v2/user-permissions/channels`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  // phân quyền camera người dùng
  changeUserCameraPermission(data) {
    let api = `/camera/v2/user-permissions/channels`;
    return iotUtilService.post(api, data);
  },
  //lấy danh sách phân quyền camera của nhóm
  getListGroupCameraPermission(param) {
    let api = `/camera/v2/group-permissions/channels`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  // phân quyền camera của nhóm
  changeGroupCameraPermission(data) {
    let api = `/camera/v2/group-permissions/channels`;
    return iotUtilService.post(api, data);
  },

  // CameraAI API
  // -- Get List Select Box
  getListSelectBox: () => {
    let api = "/device/v1/ai-camera/filters";
    return iotUtilService.get(api);
  },
  // -- CameraAI  manage --
  getCameraAIManageList: function (params) {
    let api = `/device/v1/ai-camera/camera-infos`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveCameraAIManageList: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/ai-camera/camera-infos/${data._id}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/ai-camera/camera-infos`;
      return iotUtilService.post(api, data);
    }
  },

  deleteCameraAIManage: (_id) => {
    let api = `/device/v1/ai-camera/camera-infos/${_id}`;
    return iotUtilService.delete(api);
  },

  // -- CameraAI firmware Manage --
  getCameraAIFirmwareList: function (params) {
    let api = `/device/v1/ai-camera/firmwares`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveCameraAIFirmwareList: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/ai-camera/firmwares/${data._id}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/ai-camera/firmwares`;
      return iotUtilService.post(api, data);
    }
  },

  deleteCameraFirmwareManage: (_id) => {
    let api = `/device/v1/ai-camera/firmwares/${_id}`;
    return iotUtilService.delete(api);
  },

  uploadFirmwareFile: (data) => {
    let api;
    api = `/device/v1/ai-camera/firmwares/firmware-upload`;
    return iotUtilService.post(api, data);
  },

  // -- CameraAI model Manage --
  getCameraAIModelList: function (params) {
    let api = `/device/v1/ai-camera/ai-camera-model`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveCameraAIModelList: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/ai-camera/ai-camera-model/${data._id}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/ai-camera/ai-camera-model`;
      return iotUtilService.post(api, data);
    }
  },

  deleteCameraModelManage: (_id) => {
    let api = `/device/v1/ai-camera/ai-camera-model/${_id}`;
    return iotUtilService.delete(api);
  },

  uploadModelFile: (data) => {
    let api;
    api = `/device/v1/ai-camera/ai-camera-model/model-upload`;
    return iotUtilService.post(api, data);
  },

  // -- CameraAI log Manage --
  getCameraAILogList: function (params) {
    let api = `/device/v1/ai-camera/camera-logs`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  // -- CameraAI User Manage --
  getCameraAIUserList: function (params) {
    let api = `/device/v1/ai-camera/detection-users`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveCameraAIUserList: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/ai-camera/detection-users/${data.username}`;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/ai-camera/detection-users`;
      return iotUtilService.post(api, data);
    }
  },

  deleteCameraAIUser: (_id) => {
    let api = `/device/v1/ai-camera/detection-users/${_id}`;
    return iotUtilService.delete(api);
  },

  // -- Admin devices - firmware Manage --
  getFirmwareList: function (params) {
    let api = `/device/v1/device-firmware/find-firmware`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveFirmwareList: (data, isEdit) => {
    let api;
    // if (isEdit) {
    //   api = `/device/v1/device-firmware/${data._id}`;
    //   if (data._id) delete data._id;
    //   return iotUtilService.put(api, data);
    // }
    if (!isEdit) {
      api = `/device/v1/device-firmware`;
      return iotUtilService.post(api, data);
    }
  },

  getDeviceList: function (params) {
    let api = `/device/v1/device-firmware/find-device`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  getListFilterSelectBox(param) {
    let api = `/device/v1/device-firmware/filter`;
    return iotUtilService.get(api, {
      params: param,
    });
  },

  getFirmwareUpdateHistory(params) {
    let api = `/device/v1/device-firmware/find-update-firmware-history`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveDeviceList: (data) => {
    let api = `/device/v1/device-firmware/update-firmware`;
    return iotUtilService.post(api, data);
  },

  getListFirmwareByDevice(param) {
    let api = `/device/v1/device-firmware/get-firmware-by-type`;
    return iotUtilService.get(api, {
      params: param,
    });
  },

  // Màn hình incident thiết bị
  getIncidentDeviceList: function (params) {
    let api = `/gdms/v1/incident/find-ticket`;
    // let api = `/v1/device-firmware/find-device`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  getErrorByDevice: (params) => {
    let api = `/gdms/v1/incident/error-code`;
    return iotUtilService.get(api, {
      params: params,
    });
  },
  getErrorByDeviceId: (params) => {
    let api = `/gdms/v1/incident/device/error-code`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  getFilterTags: (params) => {
    let api = `/gdms/v1/incident/filter`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  saveIncidentNote: (data) => {
    let api = `/gdms/v1/incident/note`;
    return iotUtilService.post(api, data);
  },

  saveIncidentToUrgent: (data) => {
    let api = `/gdms/v1/incident/priority`;
    return iotUtilService.post(api, data);
  },

  updateIncidentError: (data) => {
    let api = `/gdms/v1/incident/update-error`;
    return iotUtilService.post(api, data);
  },

  updateIncidentStatus: (data) => {
    let api = `/gdms/v1/incident/update-status`;
    return iotUtilService.post(api, data);
  },

  joinGroupChat: (data) => {
    let api = `/gdms/v1/incident/join-group`;
    return iotUtilService.post(api, data);
  },

  createIncident: (data) => {
    let api = `/gdms/v1/incident`;
    return iotUtilService.post(api, data);
  },

  uploadImageIncident: (data) => {
    let api = `/gdms/v1/incident/proof-upload`;
    return iotUtilService.post(api, data);
  },

  updateLegoDetail: (data) => {
    let api = `/gdms/v1/incident/update-error-details`;
    return iotUtilService.post(api, data);
  },

  exportLegoIncident: (params) => {
    let api = `/gdms/v1/incident/export-to-excel`;
    return axiosBlobInstance.get(api, { params });
  },

  getSortingDevices: () => {
    let api = `/gdms/v1/sorting-device/chain-type`;
    return iotUtilService.get(api);
  },

  // Quản lý băng tải - Lego
  getConveyor(params) {
    let api = `/gdms/v1/device/conveyor/search`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createConveyor(params, isCreate) {
    let api;
    if (!isCreate) {
      api = `/gdms/v1/device/conveyor`;
      return iotUtilService.put(api, params);
    }
    if (isCreate) {
      api = `/gdms/v1/device/conveyor`;
      return iotUtilService.post(api, params);
    }
  },

  deleteConveyor(id) {
    let api = `/gdms/v1/device/conveyor?device_id=${id}`;
    return iotUtilService.delete(api);
  },

  exportConveyor(params) {
    let api = `/gdms/v1/device/conveyor/export-excel`;
    return axiosBlobInstance.get(api, { params });
  },

  // Quản lý máng chia
  getChutes(params) {
    let api = `/gdms/v1/wms/chute/find`;
    return iotUtilService.get(api, {
      params,
    });
  },

  deleteChute(id) {
    let api = `/gdms/v1/wms/chute?id=${id}`;
    return iotUtilService.delete(api);
  },

  createChute(params, isCreate) {
    let api;
    if (!isCreate) {
      api = `/gdms/v1/wms/chute/update`;
      return iotUtilService.post(api, params);
    }
    if (isCreate) {
      api = `/gdms/v1/wms/chute`;
      return iotUtilService.post(api, params);
    }
  },

  // Firmware cho cân và trụ bựu cục
  getSmartScaleFirmwareList: function (params) {
    let api = `/device/v1/smart-scale/firmwares`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  deleteSmartScaleFirmware(id) {
    let api = `/device/v1/smart-scale/firmwares?firmware_info_id=${id}`;
    return iotUtilService.delete(api);
  },

  saveSmartScaleFirmwareList: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/smart-scale/firmwares/${data._id}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/smart-scale/firmwares`;
      return iotUtilService.post(api, data);
    }
  },

  getSmartScaleFirmwareDetail: function (id) {
    let api = `/device/v1/smart-scale/firmwares/detail/${id}`;
    return iotUtilService.get(api);
  },

  getSmartScaleFilter: function () {
    let api = `/device/v1/smart-scale/firmwares/filters`;
    return iotUtilService.get(api);
  },

  updateSmartScaleFirmwareVersion: (data) => {
    let api = `/device/v1/smart-scale/firmwares/force-update`;
    return iotUtilService.post(api, data);
  },

  // Model cho cân và trụ bựu cục
  getSmartScaleCameraFirmwareList: function (params) {
    let api = `/device/v1/smart-scale/camera-firmware`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  deleteSmartScaleModel(id) {
    let api = `/device/v1/smart-scale/camera-firmware/${id}`;
    return iotUtilService.delete(api);
  },

  saveSmartScaleCameraFirmwareUpsert: (data, isEdit, version) => {
    let api;
    if (isEdit) {
      api = `/device/v1/smart-scale/camera-firmware/${version}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/smart-scale/camera-firmware`;
      return iotUtilService.post(api, data);
    }
  },

  getSmartScaleModelDetail: function (id) {
    let api = `/device/v1/smart-scale/models/detail/${id}`;
    return iotUtilService.get(api);
  },

  getSmartScaleCameraFirmwareFilter: function (params) {
    let api = `/device/v1/smart-scale/camera-firmware/filters?scale_option=${
      params["scale_option"]
    }`;
    return iotUtilService.get(api);
  },

  // Controller cho cân và trụ bựu cục
  getSmartScaleControllerList: function (params) {
    let api = `/device/v1/smart-scale/controller`;
    return iotUtilService.get(api, {
      params: params,
    });
  },

  deleteSmartScaleController(id) {
    let api = `/device/v1/smart-scale/controller/${id}`;
    return iotUtilService.delete(api);
  },

  saveSmartScaleController: (data, isEdit) => {
    let api;
    if (isEdit) {
      api = `/device/v1/smart-scale/controller/${data._id}`;
      if (data._id) delete data._id;
      return iotUtilService.put(api, data);
    }
    if (!isEdit) {
      api = `/device/v1/smart-scale/controller`;
      return iotUtilService.post(api, data);
    }
  },

  getSmartScaleControllerFilter: function (params) {
    let api = `/device/v1/smart-scale/controller/filters`;
    return iotUtilService.get(api, { params });
  },

  saveSmartScaleControllerLog: (data) => {
    let api = `/device/v1/smart-scale/controller/repair-logs/${data._id}`;
    if (data._id) delete data._id;
    return iotUtilService.post(api, data);
  },

  deleteControllerLog(data) {
    let api = `/device/v1/smart-scale/controller/repair-logs/${data.scaleId}/${
      data.logId
    }`;
    return iotUtilService.delete(api);
  },

  // Quản lý camera smartlock
  getListCameraSmartlock: function (param) {
    let api = `/camera/v2/smart-lock-cameras`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  deleteCameraSmartlock: function (id) {
    let api = `/camera/v2/smart-lock-cameras/${id}`;
    return iotUtilService.delete(api);
  },
  createCameraSmartlock: function (dvr) {
    let api = `/camera/v2/smart-lock-cameras`;
    return iotUtilService.post(api, dvr);
  },
  updateCameraSmartlock: function (data) {
    let api = `/camera/v2/smart-lock-cameras/${data._id}`;
    if (data._id) delete data._id;
    return iotUtilService.put(api, data);
  },
  getListSmartLockByStation: function (param) {
    let api = `device/v1/smart-lock/macs`;
    return iotUtilService.get(api, {
      params: param,
    });
  },
  getSmartLockStations: function () {
    let api = `device/v1/stations`;
    return iotUtilService.get(api, {
      params: { component: "SMARTLOCK" },
    });
  },

  // Barrier car manage
  getBarrierCarList: function (params) {
    let api = `barrier/api/license/car`;
    return iotUtilService.get(api, {
      params,
    });
  },
  deleteBarrierCar: function (license_plate) {
    let api = `barrier/api/license?license_plate=${license_plate}`;
    return iotUtilService.delete(api);
  },
  addBarrierCar(data) {
    let api = `barrier/api/license`;
    return iotUtilService.post(api, data);
  },

  editBarrierCar(data) {
    let api = `barrier/api/license`;
    if (data._id) delete data._id;
    return iotUtilService.put(api, data);
  },

  getSmartScaleV2: function (params) {
    let api = `device/v1/smart-scale`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getDetailScaleV2: function (params) {
    let api = `device/v1/smart-scale/details-scale`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getSmartBarcodeScaleLog: function (params) {
    let api = `device/v1/smart-scale/logs`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getProfileLegoLog: function (params) {
    let api = `gdms/v1/device/conveyor/activity-logs`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getProfileLegoLogDetail: function (params) {
    let api = `gdms/v1/maintain/tasks/detail`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getSmartScaleV2Log: function (params) {
    let api = `device/v1/smart-scale/logs-v2`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getSmartScaleLog: function (params) {
    let api = `device/v1/scale/find-images-mac`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createErrorReport: (data) => {
    let api = `/gdms/v1/error-report`;
    return iotUtilService.post(api, data);
  },

  getCallCenterLog: function (params) {
    let api = `smsc/cdr`;
    return iotUtilService.get(api, {
      params,
    });
  },

  getCallCenterDownload: function (params) {
    let api = `smsc/v1/voip/record-file`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },

  exportCallCenterLog: function (params) {
    let api = `/smsc/cdr/export`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },

  getTenantSelect: function () {
    let api = `smsc/v1/call-center/tenant/all`;
    return iotUtilService.get(api);
  },

  getTenantList: function (params) {
    let api = `/smsc/v1/call-center/tenant`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createTenant: function (data) {
    let api = `/smsc/v1/call-center/tenant`;
    return iotUtilService.post(api, data);
  },

  updateTenant: function (data) {
    {
      let api = `/smsc/v1/call-center/tenant`;
      return iotUtilService.put(api, data);
    }
  },

  deleteTenant: function (data) {
    let api = `/smsc/v1/call-center/tenant/`;
    return iotUtilService.delete(api, {}, { data });
  },

  getSchemaList: function (params) {
    let api = `/smsc/v1/cdr/schema/list`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createSchema: function (type, data) {
    let api = `/smsc/v1/cdr/schema/${type}`;
    return iotUtilService.post(api, data);
  },

  updateSchema: function (type, data) {
    let api = `/smsc/v1/cdr/schema/${type}`;
    return iotUtilService.put(api, data);
  },

  deleteSchema: function (params) {
    let api = `/smsc/v1/cdr/schema/${params.type}?context=${params.context}&exten=${params.exten}&priority=${params.priority}`;
    return iotUtilService.delete(api);
  },

  exportEffectLogs: function (params) {
    let api = `/camera/v2/effect-logs/export`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },

  exportCameraUserPermissions: function (params) {
    let api = `/camera/v2/user-permissions/export`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },

  getUserCallCenter: function (params) {
    let api = `smsc/call/subscribers/users`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createCallCenterUser: function (data) {
    let api = `smsc/call/subscribers/users`;
    return iotUtilService.post(api, data);
  },

  updateCallCenterUser: function (data) {
    let api = `smsc/call/subscribers/users`;
    return iotUtilService.put(api, data);
  },

  deleteCallCenterUser: function (data) {
    let api = `smsc/call/subscribers/users`;
    return iotUtilService.delete(api, {}, { data });
  },

  getPhoneEndpoint: function (params) {
    let api = `smsc/api/v1/call/phone-endpoint`;
    return iotUtilService.get(api, {
      params,
    });
  },

  createPhoneEndpoint: function (data) {
    let api = `smsc/api/v1/call/phone-endpoint`;
    return iotUtilService.post(api, data);
  },

  updatePhoneEndpoint: function (data) {
    let api = `smsc/api/v1/call/phone-endpoint`;
    return iotUtilService.put(api, data);
  },

  deletePhoneEndpoint: function (data) {
    let api = `smsc/api/v1/call/phone-endpoint`;
    return iotUtilService.delete(api, {}, { data });
  },

  getEndpointSelect: function () {
    let api = `smsc/api/v1/call/ps-endpoint`;
    return iotUtilService.get(api);
  },

  getEndpointStatus: function () {
    let api = `smsc/api/v1/call/phone-endpoint/status`;
    return iotUtilService.get(api);
  },

  getTruckCameraPermissionList(param) {
    let api = `/camera/v2/truck-camera-permissions`;
    return iotUtilService.get(api, {
      params: param,
    });
  },

  createTruckCameraPermission(data) {
    let api = `/camera/v2/truck-camera-permissions`;
    return iotUtilService.post(api, data);
  },

  updateTruckCameraPermission(data, _id) {
    let api = `/camera/v2/truck-camera-permissions/${_id}`;
    return iotUtilService.put(api, data);
  },

  deleteTruckCameraPermission(id) {
    let api = `/camera/v2/truck-camera-permissions/${id}`;
    return iotUtilService.delete(api);
  },

  getTrunkAORList(param) {
    let api = `/smsc/v1/trunk/aors`;
    return iotUtilService.get(api, {
      params: param,
    });
  },

  createTrunkAOR(data) {
    let api = `/smsc/v1/trunk/aors`;
    return iotUtilService.post(api, data);
  },

  updateTrunkAOR(data, _id) {
    let api = `/smsc/v1/trunk/aors`;
    return iotUtilService.put(api, data);
  },

  deleteTrunkAOR(id) {
    let api = `/smsc/v1/trunk/aors/${id}`;
    return iotUtilService.delete(api);
  },

  getTrunkEndpointList(param) {
    let api = `/smsc/v1/trunk/endpoints`;
    return iotUtilService.get(api, {
      params: param,
    });
  },

  createTrunkEndpoint(data) {
    let api = `/smsc/v1/trunk/endpoints`;
    return iotUtilService.post(api, data);
  },

  updateTrunkEndpoint(data) {
    let api = `/smsc/v1/trunk/endpoints`;
    return iotUtilService.put(api, data);
  },

  deleteTrunkEndpoint(id) {
    let api = `/smsc/v1/trunk/endpoints/${id}`;
    return iotUtilService.delete(api);
  },

  getTrunkEndpointDetail(id) {
    let api = `/smsc/v1/trunk/endpoints/${id}`;
    return iotUtilService.get(api);
  },

  handleDownloadCallCenterLog(params) {
    let api = `/smsc/v1/voip/record-file/download`;
    return printerUtilService.get(api, { params, responseType: "blob" });
  },
};
